import BaseType from "./BaseType";

export default class TuerFluegel extends BaseType(THREE.Group) {

    constructor(vsData) {
        super(vsData);
    }

}

